import React from "react";
import { Box } from "@mui/material";

const FrameCard = ({ children, sx = {} }) => {
  return (
    <Box
      sx={{
        backgroundColor: "#F9FAFF",
        borderRadius: "20px",
        boxShadow: `
          10px 10px 20px hsla(0, 0%, 0%, 0.3),
          inset 2px 2px 0px rgba(255, 255, 255, 1)
        `,
        p: 3,
        ...sx,
      }}
    >
      { children }
    </Box>
  );
};

export default FrameCard;